<template>
  <div>
    <div ref="slider" class="slider"></div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import wNumb from "wnumb";

export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [2, 10]
    },
  },
  data() {
    return {
      sliderValues: [...this.modelValue],
    };
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const slider = this.$refs.slider;

      noUiSlider.create(slider, {
        range: {
          min: 1,
          max: 10,
        },
        step: 1,
        start: this.sliderValues,
        margin: 0,
        limit: 10,
        connect: true,
        direction: "ltr",
        orientation: "horizontal",
        behaviour: "tap-drag",
        format: wNumb({
          decimals: 0,
        }),
        pips: {
          mode: "range",
          values: [1, 10],
          stepped: true,
          density: 11,
        },
      });

      slider.noUiSlider.on("update", (values) => {
        this.sliderValues = values.map(Number);
        this.$emit("update:modelValue", this.sliderValues);
      });
    },
  },
  watch: {
    modelValue(newValues) {
      if (this.$refs.slider && this.$refs.slider.noUiSlider) {
        this.$refs.slider.noUiSlider.set(newValues);
      }
    },
  },
};
</script>

<style scoped>
.slider {
  width: 144px;
  height: 10px;
  margin: 20px auto;
}

::v-deep(.noUi-connect) {
  background: black !important;
}

::v-deep(.noUi-handle) {
  background: black !important;
  border-color: black !important;
  width: 20px !important;
  height: 15px !important;
  right: -10px !important;
  top: -4px !important;
  cursor: pointer !important;
}

::v-deep(.noUi-handle:after),
::v-deep(.noUi-handle:before) {
  display: block;
  position: absolute;
  height: 10px;
  width: 1px;
  background: #e8e7e6;
  left: 6px;
  top: 2px;
  box-shadow: 4px 0px #e8e7e6;
}

::v-deep(.noUi-pips) {
  color: black !important;
  font-size: 12px !important;
  padding: 5px 0;
}

::v-deep(.noUi-marker-large) {
  height: 10px !important;
}
::v-deep(.noUi-marker) {
  background: black !important;
}
</style>
